module.exports = {"25x66": __webpack_public_path__ + "images/satellite-2-66x25.png"};